module.exports = __webpack_public_path__ + "static/media/save.4d9b9a5a.svg";